<!-- 连续型电子出版物 -->

<template>
	<div class="press-6">

		<MainTabs v-if="wSat == 1" :pressDat="resDat" role="press" :bookName="bookname" />
	</div>
</template>

<script>
	import MainTabs from '@/views/components/SPEC/ssCommonTabs';
    import { getSuccessTabs } from '@/api/pressRole/pressSuccessive';
    export default{
         components:{
             MainTabs
         },
    	 data(){
    	 	 return{
                wSat:0,
				bookname:this.$route.query.bookName,
                resDat:[{}]
    	 	 }
    	 },
       created:function(){
		 getSuccessTabs({
			  publishMaterialId:this.$route.query.listId,
			  organizationId:this.$route.query.pressId
		 }).then(response => {
			  let vm = this;
			  vm.wSat = 1;
			  this.resDat.splice(0,1,response.ppublicationOrganizationMaterialList);
		 })
       }
    }

</script>

<style lang="scss" scoped type="text/css">
    .press-6{
        padding:0px 12px;
        margin-bottom:30px;

        .subLine{
            text-align: center;
            margin: 0px 0px 50px;

            .el-button{
                width: 180px;
                margin-top: 12px;
            }
        }

				.headBar{
            padding: 0px 24px;
            height: 45px;
            line-height: 45px;
            background: #F8F8F8;
            color: #666666;
            margin-top: 9px;
						font-size: 14px;

        }

        .succedTips{
            font-size:14px;
            color:#666666;
            padding:20px;

        }
    }

</style>



// WEBPACK FOOTER //
// skimFrame.vue?4066e5e2